<template>
  <div>
    <AutoCompleteSelect
      :value="value"
      :store="store"
      :multiple="true"
      @selectChanged="selectChanged"
      @operatorChanged="operatorChanged"
      :operators="['in', 'not_in', 'empty']"
      :placeholder="$t('agreement-type.text')"
    />
  </div>
</template>

<script>
import AutoCompleteSelect from "./AutoCompleteSelect";
import { methods } from "./commons";

export default {
  props: ["value"],

  components: { AutoCompleteSelect },
  data() {
    return { store: "agreementType" };
  },
  methods,
};
</script>
